import React from 'react';

import { LoaderContainer, LoaderSpinner } from './styled';

export const Loader = ({ isFull = false }: { isFull?: boolean }) => {
  return (
    <LoaderContainer $isFull={isFull}>
      <LoaderSpinner />
    </LoaderContainer>
  );
};
